export default __webpack_public_path__ + "static/media/nav-image.78206ba6.png";